import { createAsyncThunk, isRejected } from '@reduxjs/toolkit';
import {
  actions as appStorageActions,
  constants as appStorageConstants,
  utils as appStorageUtils,
} from '@saucelabs/sl-module-app-storage';

import api, { ServerNewPreset } from './api';
import types from './types';

const fetchPresets = createAsyncThunk(
  types.PRESETS_FETCH,
  async (noArgument, { rejectWithValue }) => {
    try {
      const response = await api.fetchPresets();
      return response.data;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      return rejectWithValue(error.response.data);
    }
  },
);

const createOrUpdateRecentPreset = createAsyncThunk(
  types.PRESETS_POST,
  async (payload: ServerNewPreset, { rejectWithValue }) => {
    try {
      const response = await api.postRecentPreset(payload);
      return response.data;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      return rejectWithValue(error.response.data);
    }
  },
);

const fetchAppStorageFiles = createAsyncThunk(
  types.PRESETS_FETCH_FILES,
  async (fileIds: string[], { dispatch, rejectWithValue }) => {
    try {
      const fetchFilesResponse = await dispatch(appStorageActions.fetchFiles({
        iconRepresentation: appStorageConstants.APP_STORAGE_ICON_REPRESENTATION.hash,
        fileId: [...new Set(fileIds)],
      }));

      if (isRejected(fetchFilesResponse)) {
        const serverError = fetchFilesResponse.payload as appStorageUtils.SerializedApiError;
        throw serverError;
      }

      return fetchFilesResponse.payload;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      if (error instanceof Error) {
        return rejectWithValue(appStorageUtils.handleApiError(error));
      }

      return rejectWithValue(error);
    }
  },
);

export default {
  createOrUpdateRecentPreset,
  fetchAppStorageFiles,
  fetchPresets,
};
